import React from "react";
import { cls } from "shared/lib/util/classnames";

interface Props {
  color?: "blue" | "white";
  label: string;
  onClick: () => void;
  isDisabled?: boolean;
}

export function PrimaryBtn({
  color = "blue",
  label,
  onClick,
  isDisabled,
}: Props) {
  return (
    <button
      disabled={isDisabled}
      onClick={onClick}
      className={cls(
        color === "blue"
          ? "border-blue-1 bg-blue-1 text-white"
          : "border-gray-3 bg-white text-gray-5",
        "rounded-[8px] border-[1px] px-[35px] py-[15px] text-M3 disabled:border-gray-1 disabled:bg-gray-1 disabled:text-gray-4",
      )}
    >
      {label}
    </button>
  );
}
